import { useMutation } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import ChurchService from '@/services/church.service';
import type { ContactFormRequestPayload } from '@/types';

type ContactFormMutationParams = {
  churchId: string;
  data: ContactFormRequestPayload;
};

export const useContactFormMutation = () => {
  const { showLoadingNotification, showSuccessNotification, showErrorNotification } = useNotification();

  return useMutation({
    mutationFn: ({ churchId, data }: ContactFormMutationParams) => ChurchService.submitContactForm(churchId, data),
    onMutate: () => {
      showLoadingNotification({
        action: 'submitting contact form',
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        action: 'submitted contact form',
      });
    },
    onError: (error) => showErrorNotification(error),
  });
};
